import React from 'react';

const Spacer = ({ height = 8 }) => <div style={{ height }} />;

export default Spacer;
